import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          But in February 2022, N50 was only just getting off the ground. Even so, Hartshorn and
          Gutwein realized that N50 might be able to leverage the strengths and expertise of its
          member organizations—and its collaborative model—to provide communications and to help
          Ukrainians in dire need. “The real story,” Gutwein says, “is... how quickly we started
          working together under a common goal of providing communications and information and power
          to a dispersed group of people.”
        </p>
        <p className="chapter__paragraph">
          N50 had decided to act - but what would that action look like? With the help of more than
          a dozen N50 partner organizations, the solution began to take shape immediately. One of
          the partners that was instrumental in building, integrating, and deploying the PCCs was
          Computer Aid International, a non-profit organization that uses computers and other ICT
          equipment to improve lives and specialize in deploying Dell Solar Community Hubs as
          computer centers in remote locations.
        </p>
        <p className="chapter__paragraph">
          The coalition coordinated with a group of some 50 non-government aid organizations to
          figure out what Ukrainian refugees needed most. The country’s IT infrastructure is
          well-developed, and Ukrainians are used to a high level of internet connectivity. They
          needed digital solutions that would allow them to communicate with family and friends back
          in Ukraine and access information that would allow adults to search for jobs and children
          to continue their education. Furthermore, they learned that refugees desperately needed
          education and accurate information about human traffickers who were using the crisis to
          prey on the most vulnerable.
        </p>
        <p className="chapter__paragraph">
          The solution that delivered these needs would have to be portable, modular, easy-to-power,
          and able to connect large numbers of refugees to digital resources. Ultimately, N50
          designed a solution that would become known as the Portable Connectivity Center (PCC), a
          modular shipping container that included everything refugees might require to access the
          digital tools and solutions they needed most But whether the team could build such a
          container — or how quickly — was another matter entirely.
        </p>
      </section>
    </>
  );
}

export default Chapter5;
